import React, { useState, useRef } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import api from '../api/api';

const Register = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const formRef = useRef(null);

    // 🔥 A MÁGICA AQUI: Lê o ID e verifica se o plano é de graça
    const planoSelecionadoId = location.state?.planoId || null;
    const isPlanoPago = location.state ? !location.state.isFree : false; // Se entrar direto na rota, assume FREE

    const [etapaAtual, setEtapaAtual] = useState(1);
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [loading, setLoading] = useState(false);
    const [termosAceitos, setTermosAceitos] = useState(false);

    // Dados da Empresa e Usuário
    const [dados, setDados] = useState({
        razaoSocial: '',
        cnpj: '',
        nomeResponsavel: '',
        chavePix: '',
        cpf: '',
        email: '',
        telefone: '',
        login: '',
        senha: '',
        planoId: planoSelecionadoId
    });

    // Dados do Cartão de Crédito
    const [cartao, setCartao] = useState({
        numero: '',
        mesVencimento: '',
        anoVencimento: '',
        cvv: '',
        nomeImpresso: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'cnpj') {
            setDados(prev => ({ ...prev, [name]: value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() }));
        } else if (name === 'cpf') {
            setDados(prev => ({ ...prev, [name]: value.replace(/\D/g, '') }));
        } else {
            setDados(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleCartaoChange = (e) => {
        const { name, value } = e.target;
        if (name === 'nomeImpresso') {
            setCartao(prev => ({ ...prev, [name]: value.toUpperCase() }));
        } else {
            setCartao(prev => ({ ...prev, [name]: value.replace(/\D/g, '') }));
        }
    };

    const handleFileChange = (e) => {
        setFotoPerfil(e.target.files[0]);
    };

    const avancarEtapa = () => {
        if (formRef.current.reportValidity()) {
            setEtapaAtual(2);
        }
    };

    const gerarTokenEfi = async () => {
        return new Promise((resolve, reject) => {
            if (!window.$gn) {
                reject("Script de pagamento não carregado.");
                return;
            }

            const checkout = new window.$gn({
                account_code: 'SEU_ACCOUNT_CODE_DA_EFI_AQUI',
                sandbox: true
            });

            checkout.getPaymentToken({
                brand: 'visa',
                number: cartao.numero,
                cvv: cartao.cvv,
                expiration_month: cartao.mesVencimento,
                expiration_year: cartao.anoVencimento
            }, function(error, response) {
                if (error) reject(error);
                else resolve(response.data.payment_token);
            });
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Se estiver na etapa 1 e for plano pago, apenas avança para o cartão
        if (etapaAtual === 1 && isPlanoPago) {
            avancarEtapa();
            return;
        }
        
        if (!termosAceitos) {
            alert("Você precisa aceitar os termos de responsabilidade para continuar.");
            return;
        }

        setLoading(true);
        let cardTokenFinal = null;

        try {
            // Só chama a Efí se o plano for efetivamente pago
            if (isPlanoPago) {
                // cardTokenFinal = "mock_token_12345"; // Descomente para testar sem a Efí conectada
                cardTokenFinal = await gerarTokenEfi();
            }

            const payload = { ...dados, cardToken: cardTokenFinal };
            const formData = new FormData();
            const jsonBlob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
            
            formData.append('dados', jsonBlob);
            if (fotoPerfil) formData.append('fotoPerfil', fotoPerfil);

            await api.post('/public/registrar', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            alert('Cadastro e assinatura realizados com sucesso! Verifique seu e-mail.');
            navigate('/login');

        } catch (error) {
            console.error(error);
            if (error.error_description) {
                alert('Erro no cartão: ' + error.error_description);
            } else if (error.response?.data) {
                alert('Erro no cadastro: ' + (error.response.data.message || 'Dados inválidos.'));
            } else {
                alert('Erro inesperado ao processar cadastro.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                
                <div style={styles.header}>
                    <button type="button" onClick={() => etapaAtual === 2 ? setEtapaAtual(1) : navigate('/')} style={styles.btnVoltar}>
                        ← {etapaAtual === 2 ? 'Voltar aos Dados Pessoais' : 'Voltar para a Home'}
                    </button>
                    {isPlanoPago && (
                        <div style={styles.passos}>Passo {etapaAtual} de 2</div>
                    )}
                </div>

                <h2 style={styles.title}>
                    {isPlanoPago && etapaAtual === 2 ? 'Finalize sua assinatura PRO' : 'Crie sua conta no '}
                    {(!isPlanoPago || etapaAtual === 1) && <span className="text-gradient" style={{ color: '#10b981' }}>QuitaGo</span>}
                </h2>
                <p style={styles.subtitle}>
                    {etapaAtual === 2 ? 'Ambiente seguro e criptografado.' : 'Comece agora a gerenciar seus devedores.'}
                </p>

                <form ref={formRef} onSubmit={handleSubmit} style={styles.form}>
                    
                    {/* ETAPA 1: DADOS DA AGÊNCIA */}
                    <div style={{ display: etapaAtual === 1 ? 'block' : 'none' }}>
                        <div style={styles.sectionTitle}>Dados da Agência</div>
                        <div style={styles.grid}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Razão Social</label>
                                <input type="text" name="razaoSocial" value={dados.razaoSocial} required onChange={handleChange} style={styles.input} placeholder="Nome da Empresa" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>CNPJ (apenas números)</label>
                                <input type="text" name="cnpj" value={dados.cnpj} maxLength="14" required onChange={handleChange} style={styles.input} placeholder="00000000000000" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Nome do Responsável</label>
                                <input type="text" name="nomeResponsavel" value={dados.nomeResponsavel} required onChange={handleChange} style={styles.input} placeholder="Seu nome completo" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>CPF do Responsável</label>
                                <input type="text" name="cpf" value={dados.cpf} maxLength="11" required onChange={handleChange} style={styles.input} placeholder="00000000000" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Chave PIX (Para receber comissões)</label>
                                <input type="text" name="chavePix" value={dados.chavePix} required onChange={handleChange} style={styles.input} placeholder="CPF, E-mail, Celular ou Aleatória" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>E-mail Corporativo</label>
                                <input type="email" name="email" value={dados.email} required onChange={handleChange} style={styles.input} placeholder="exemplo@empresa.com" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Telefone / WhatsApp</label>
                                <input type="text" name="telefone" value={dados.telefone} onChange={handleChange} style={styles.input} placeholder="(81) 99999-9999" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Foto de Perfil (Opcional)</label>
                                <input type="file" accept="image/*" onChange={handleFileChange} style={styles.fileInput} />
                            </div>
                        </div>

                        <div style={styles.sectionTitle}>Acesso ao Painel</div>
                        <div style={styles.grid}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Login de Acesso</label>
                                <input type="text" name="login" value={dados.login} required onChange={handleChange} style={styles.input} placeholder="usuario.admin" />
                            </div>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Senha</label>
                                <input type="password" name="senha" value={dados.senha} required onChange={handleChange} style={styles.input} placeholder="••••••••" />
                            </div>
                        </div>

                        {/* O Checkbox aparece na Etapa 1 APENAS se for plano grátis */}
                        {!isPlanoPago && (
                            <div style={styles.checkboxWrapper}>
                                <input type="checkbox" id="aceiteTermos1" checked={termosAceitos} onChange={(e) => setTermosAceitos(e.target.checked)} style={styles.checkbox} />
                                <label htmlFor="aceiteTermos1" style={styles.checkboxLabel}>Declaro que li e aceito os Termos de Responsabilidade (LGPD).</label>
                            </div>
                        )}

                        {/* Botão Dinâmico da Etapa 1 */}
                        {isPlanoPago ? (
                            <button type="button" onClick={avancarEtapa} style={styles.button}>Continuar para Pagamento →</button>
                        ) : (
                            <button type="submit" disabled={loading || !termosAceitos} style={{ ...styles.button, opacity: (loading || !termosAceitos) ? 0.5 : 1 }}>
                                {loading ? 'Processando...' : 'Finalizar Cadastro Gratuito'}
                            </button>
                        )}
                    </div>

                    {/* ETAPA 2: CARTÃO DE CRÉDITO (Só renderiza se for plano pago) */}
                    {isPlanoPago && (
                        <div style={{ display: etapaAtual === 2 ? 'block' : 'none' }}>
                            
                            <div style={styles.secureBadge}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                                <span>Pagamento 100% Seguro Processado pela <strong>Efí</strong></span>
                            </div>

                            <div style={styles.creditCardBox}>
                                <div style={styles.inputGroup}>
                                    <label style={styles.labelCartao}>Número do Cartão</label>
                                    <div style={styles.inputIconWrapper}>
                                        <svg style={styles.inputIcon} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
                                        <input type="text" name="numero" value={cartao.numero} maxLength="16" required={etapaAtual === 2} onChange={handleCartaoChange} style={styles.inputCard} placeholder="0000 0000 0000 0000" />
                                    </div>
                                </div>
                                
                                <div style={styles.inputGroup}>
                                    <label style={styles.labelCartao}>Nome Impresso no Cartão</label>
                                    <input type="text" name="nomeImpresso" value={cartao.nomeImpresso} required={etapaAtual === 2} onChange={handleCartaoChange} style={styles.inputCardLiso} placeholder="JOAO DA SILVA" />
                                </div>

                                <div style={styles.cardGrid}>
                                    <div style={styles.inputGroup}>
                                        <label style={styles.labelCartao}>Validade (MM/AAAA)</label>
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <input type="text" name="mesVencimento" value={cartao.mesVencimento} maxLength="2" required={etapaAtual === 2} onChange={handleCartaoChange} style={{...styles.inputCardLiso, textAlign: 'center'}} placeholder="MM" />
                                            <span style={{color: '#94a3b8', fontSize: '1.5rem', alignSelf: 'center'}}>/</span>
                                            <input type="text" name="anoVencimento" value={cartao.anoVencimento} maxLength="4" required={etapaAtual === 2} onChange={handleCartaoChange} style={{...styles.inputCardLiso, textAlign: 'center'}} placeholder="AAAA" />
                                        </div>
                                    </div>
                                    
                                    <div style={styles.inputGroup}>
                                        <label style={styles.labelCartao}>CVV</label>
                                        <div style={styles.inputIconWrapper}>
                                            <input type="text" name="cvv" value={cartao.cvv} maxLength="4" required={etapaAtual === 2} onChange={handleCartaoChange} style={{...styles.inputCardLiso, paddingRight: '40px'}} placeholder="123" />
                                            <svg style={{...styles.inputIcon, right: '12px', left: 'auto'}} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12.01" y2="16"></line><path d="M12 8v4"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={styles.checkboxWrapper}>
                                <input type="checkbox" id="aceiteTermos2" checked={termosAceitos} onChange={(e) => setTermosAceitos(e.target.checked)} style={styles.checkbox} />
                                <label htmlFor="aceiteTermos2" style={styles.checkboxLabel}>Declaro que li e aceito os Termos de Responsabilidade e autorizo a cobrança mensal recorrente.</label>
                            </div>

                            <button type="submit" disabled={loading || !termosAceitos} style={{ ...styles.button, opacity: (loading || !termosAceitos) ? 0.5 : 1 }}>
                                {loading ? 'Processando Pagamento...' : '💳 Assinar e Criar Conta'}
                            </button>
                        </div>
                    )}
                </form>

                <p style={styles.footerText}>
                    Já tem uma conta? <Link to="/login" style={styles.link}>Entre aqui</Link>
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#020617', padding: '40px 20px' },
    card: { background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.1)', padding: 'clamp(20px, 5vw, 40px)', borderRadius: '16px', maxWidth: '800px', width: '100%', boxSizing: 'border-box', backdropFilter: 'blur(10px)' },
    
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
    btnVoltar: { background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer', fontSize: '0.95rem', padding: 0, transition: 'color 0.2s' },
    passos: { background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', padding: '4px 12px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold' },
    
    title: { fontSize: 'clamp(1.5rem, 4vw, 2rem)', fontWeight: '800', marginBottom: '10px', textAlign: 'center', color: 'white' },
    subtitle: { color: '#94a3b8', textAlign: 'center', marginBottom: '30px', fontSize: 'clamp(0.85rem, 2vw, 1rem)' },
    form: { display: 'flex', flexDirection: 'column', gap: '20px' },
    sectionTitle: { color: '#10b981', fontSize: '1.1rem', fontWeight: 'bold', borderBottom: '1px solid rgba(16, 185, 129, 0.2)', paddingBottom: '8px', marginTop: '10px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: '20px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
    label: { color: '#f8fafc', fontSize: '0.9rem', fontWeight: '600' },
    input: { background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '8px', padding: '12px', color: 'white', outline: 'none', fontSize: '1rem', width: '100%', boxSizing: 'border-box' },
    fileInput: { color: '#94a3b8', fontSize: '0.9rem', width: '100%' },
    
    secureBadge: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', background: 'rgba(16, 185, 129, 0.05)', border: '1px solid rgba(16, 185, 129, 0.2)', color: '#10b981', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '0.9rem' },
    creditCardBox: { background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)', border: '1px solid rgba(255,255,255,0.1)', padding: '25px', borderRadius: '16px', display: 'flex', flexDirection: 'column', gap: '20px', boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)' },
    labelCartao: { color: '#94a3b8', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '1px' },
    inputIconWrapper: { position: 'relative', display: 'flex', alignItems: 'center' },
    inputIcon: { position: 'absolute', left: '12px', color: '#64748b' },
    inputCard: { background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '12px 12px 12px 45px', color: 'white', fontSize: '1.1rem', letterSpacing: '2px', width: '100%', outline: 'none', fontFamily: 'monospace' },
    inputCardLiso: { background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '12px', color: 'white', fontSize: '1.1rem', width: '100%', outline: 'none' },
    cardGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },

    checkboxWrapper: { display: 'flex', alignItems: 'flex-start', gap: '12px', marginTop: '10px', background: 'rgba(255, 255, 255, 0.02)', padding: '15px', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.05)' },
    checkbox: { marginTop: '3px', width: '18px', height: '18px', cursor: 'pointer', accentColor: '#10b981' },
    checkboxLabel: { color: '#94a3b8', fontSize: '0.85rem', lineHeight: '1.4', cursor: 'pointer' },
    button: { background: '#10b981', color: '#022c22', padding: '15px', borderRadius: '8px', border: 'none', fontWeight: '800', fontSize: '1rem', marginTop: '10px', transition: 'all 0.3s', width: '100%' },
    footerText: { marginTop: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '0.9rem' },
    link: { color: '#10b981', textDecoration: 'none', fontWeight: '600' }
};

export default Register;